import axios from "@/libs/api.request";
// 港口增删改查
export const operProt = params => {
  return axios.request({
    url: `/common/port${params.id ? "/" + params.id : ""}`,
    params,
    method: params.method
  });
};
